import React from 'react';
import { AlertTriangle, DollarSign } from 'lucide-react';
import { SPORT_STYLES, SPORT_FALLBACK, STATUS_TEXTURE } from './constants';

/**
 * Single grid cell for a (court_number, time_slot) intersection.
 * `booking` is null/undefined when the slot is free (renders blank).
 */
export default function ScheduleCell({ booking, onClick }) {
  if (!booking) {
    return (
      <td
        className="align-top border border-gray-300 h-11 px-2 py-1 hover:bg-gray-100 transition-colors"
        data-testid="schedule-cell-empty"
      />
    );
  }

  const sty = SPORT_STYLES[booking.primary_sport] || SPORT_FALLBACK;
  const isPending = booking.status === 'AWAITING_PAYMENT';
  const isPayLaterHold =
    booking.status === 'CONFIRMED' && booking.payment_status === 'pending';
  const stripe = isPending ? STATUS_TEXTURE.AWAITING_PAYMENT : '';
  const payLaterTooltip =
    booking.final_total != null
      ? `Pay Later — $${Number(booking.final_total).toFixed(2)} owed`
      : 'Pay Later — payment owed';

  return (
    <td
      className={`align-top border-2 ${sty.border} h-11 px-2 py-1 cursor-pointer hover:opacity-90 hover:ring-2 hover:ring-gray-700 transition-all ${sty.bg} ${stripe}`}
      onClick={() => onClick(booking)}
      data-testid={`schedule-cell-booked-${booking.booking_ref}`}
    >
      <div className={`flex flex-col gap-0 leading-tight text-[11px] ${sty.text}`}>
        <div className="flex items-center gap-1">
          <span className="font-bold uppercase tracking-tight">
            {sty.label}
            {booking.duration > 1 && (
              <span className="font-semibold opacity-80"> ({booking.duration}h)</span>
            )}
          </span>
          {isPending && (
            <AlertTriangle className="w-3 h-3 text-amber-700" data-testid="awaiting-payment-icon" />
          )}
          {isPayLaterHold && (
            <span title={payLaterTooltip} className="inline-flex">
              <DollarSign
                className="w-3 h-3 text-amber-700"
                data-testid={`pay-later-hold-icon-${booking.booking_ref}`}
                aria-label={payLaterTooltip}
              />
            </span>
          )}
        </div>
        <span className="truncate font-medium" title={booking.customer_name}>
          {booking.customer_name}
        </span>
      </div>
    </td>
  );
}
